export default (clientFirstName: string) => ({
  schema: {
    type: 'object',
    properties: {
      changeReason: {
        name: 'changeReason',
        type: 'string',
        title: 'Why are you canceling this session?',
        enum: ['providerInitiated', 'clientTransition', 'clientCancel'],
        enumNames: [
          'I am unable to attend this session',
          `${clientFirstName} transitioned from my care prior to the session`,
          `${clientFirstName} canceled this session`,
        ],
        validation: {
          isRequired: true,
        },
      },
      changeNotice: {
        name: 'changeNotice',
        type: 'string',
        title: `Did ${clientFirstName} give you sufficient notice?`,
        enum: ['clientInitiated', 'clientInitiatedLate'],
        enumNames: [
          `Yes, ${clientFirstName} reached out and requested a cancellation or reschedule with sufficient notice`,
          'No, client canceled with insufficient notice',
        ],
        condition: {
          parentField: 'changeReason',
          parentValue: 'clientCancel',
        },
        validation: {
          isRequired: true,
        },
      },
    },
  },

  uiSchema: {
    'ui:order': ['title', 'changeReason', 'changeNotice'],
    changeReason: {
      'ui:widget': 'radio',
    },
    changeNotice: {
      'ui:widget': 'radio',
    },
  },
})
